import { Injectable } from '@angular/core';
import { HubConnection, HubConnectionBuilder, LogLevel } from '@microsoft/signalr';
import { ReplaySubject } from 'rxjs';
import { ConfigService } from 'src/app/@shared/services/config.service';
import { Alarm, EmergencyAlarm } from '../domain/interfaces/alarm.interface';
import { AuthService } from 'src/app/auth/services/auth.service';
import { ParkbaseStorageService } from '../../@shared/services/parkbaseStorage.service';
import { Config } from '../domain/interfaces/config.interface';
import { LogService } from '../logging/log.service';

@Injectable({
  providedIn: 'root',
})
export class DivisionHubService {
  private hubUrl!: string;
  private hubConnection!: HubConnection;
  private _divisionEmergencyAlarmsSource = new ReplaySubject<Alarm[]>();
  readonly divisionEmergencyAlarms$ = this._divisionEmergencyAlarmsSource.asObservable();

  constructor(
    private configService: ConfigService,
    private authService: AuthService,
    private parkbaseStorageService: ParkbaseStorageService,
    private logger: LogService
  ) {}

  reconnect() {
    this.stopHubConnection();
    this.connectWithConfiguration();
  }

  stop() {
    this.stopHubConnection();
    this.startConnection();
  }

  connectWithConfiguration() {
    if (!this.hubConnection) {
      this.configService.loadConfiguration().then((result: Config) => {
        this.hubUrl = result.server.resourcesBL9;
        const user = this.authService.getUser();
        const ippLanguage = this.parkbaseStorageService.getLanguageForApi();
        const connecting = true;
        const headers = { 'Ipp-Language': ippLanguage };
        if (user && connecting) {
          this.hubConnection = new HubConnectionBuilder()
            .withUrl(this.hubUrl + '/hub/division?ipp-Language=' + ippLanguage, {
              headers: headers,
              accessTokenFactory: () => user.token,
            })
            .configureLogging(LogLevel.Error)
            .withAutomaticReconnect()
            .build();

          this.startConnection();
        }
      });
    }
  }

  private startConnection() {
    this.hubConnection
      .start()
      .then(() => {
        this.logger.info('DivisionHub connection started');
      })
      .catch((error) => {
        this.logger.error('Error in Division hubConnection', error);
      });

    this.hubConnection.on('Error', (message) => {
      this.logger.error('Error in Division hubConnection', message);
    });

    this.hubConnection.on('DivisionEmergencyAlarmsChanged', (alarms: EmergencyAlarm[]) => {
      if (alarms && alarms.length > 0) {
        this._divisionEmergencyAlarmsSource.next(alarms);
        this.logger.info('DivisionHub divisionEmergencyAlarmsChanged', alarms);
      }
    });
  }

  private stopHubConnection() {
    if (this.hubConnection) {
      this.hubConnection.stop().catch((error) => {
        this.logger.error('Error in Division stopHubConnection', error);
      });
    }
  }
}
